import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './customer-detail.page.html',
})

/**
 * Customer detail page!
 */
export class CustomerDetailPage implements OnInit {
  businessId!: number;
  couponId!: number;
  /**
   * @constructor
   */
  constructor(private route: ActivatedRoute) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.businessId = this.route.snapshot.params['id'];
    this.couponId = this.route.snapshot.params['couponId'];
  }
}
